/**
 * This dialog is shown when a user tries to cancel scheduled updates
 * from either the scheduled updates sidebar or from an individual field.
 *
 * @author Manoj Kintali (mkintali@yext.com)
 */
goog.module('yext.scheduledupdates.dialog.CancelDialog');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
const notify = goog.require('yext.notify');
const ActionResultDialog = goog.require('yext.scheduledupdates.dialog.ActionResultDialog');
const ActionDialog = goog.require('yext.scheduledupdates.dialog.ActionDialog');
const Base = goog.require('yext.scheduledupdates.dialog.Base');
const routes = goog.require('yext.scheduledupdates.routes');
const time = goog.require('yext.time');


/**
 * Constructor for the CancelDialog.
 *
 * @param {string} date                       The date of the scheduled updates you're cancelling
 * @param {string=} opt_selectedFieldId        Which field we shoud select by default.
 * @param {string=} opt_selectedCustomFieldId  Which field we shoud select by default.
 *
 * @constructor
 */
const CancelDialog = function(date, opt_selectedFieldId, opt_selectedCustomFieldId) {
  var $dialog = $('.js-cancel-updates-dialog');
  ActionDialog.call(this, date, opt_selectedFieldId, opt_selectedCustomFieldId, $dialog);
};
// Inherit ScheduleUpdateDialog methods
goog.inherits(CancelDialog, ActionDialog);

/**
 * Actually populates the dialog on the page.
 */
CancelDialog.prototype.show = function() {
  var options = {
    container: this.$dialog,
    title: yext.msg('Cancel Updates for {0}', time.formatLocalizedDate(this.date, 'medium')),
  };
  options.container.find('.js-scheduled-fields').html(this.getBody());

  var self = this;
  this.$dialog.off('submit').on('submit', function() {
    self.apply();
  });

  new Base(options).show();
};

/**
 * Generates the html for the body of this cancel dialog
 */
CancelDialog.prototype.getBody = function() {
  var result = this.getFieldOptions();
  var $cancelMsg = this.$dialog.find('.js-cancel-prompt');
  $cancelMsg.toggle(false);
  if (result.error) {
    return yext.msg('Could not retrieve scheduled updates for this day.');
  } else if (result.options.length) {
    $cancelMsg.toggle(true);
    this.$dialog.find('.js-submit-btn').prop('disabled', false);
    return this.getMultiSelectBody(result.options);
  } else {
    return yext.msg('There are no scheduled updates for this day.');
  }
};

/**
 * This function is called when the user decides to hit Apply, we will fire of a request to actually cancel the
 * scheduled updates and then redirect the user back to the primary profile.
 * @suppress {deprecated}
 */
CancelDialog.prototype.apply = function() {
  // Find all the checked field and custom field ids
  var checkedOptions = this.multiSelect.getCheckedOptions();
  var checkedFieldNames = [];
  checkedOptions.forEach(function(option) {
    checkedFieldNames.push(option.id);
  });

  // Send an ajax request to cancel the scheduled updates
  var url = routes.cancel() + window.location.search;
  var requestData = {
    futureDate: this.date,
    fieldNames: checkedFieldNames,
  };

  var locationIds = yext.getUrlParams().ids;
  if (locationIds) {
    requestData.ids = decodeURIComponent(locationIds).split(',');
  }

  var self = this;
  self.dialogTimeout = dialog.showDelayedProgressDialog(yext.msg('Saving...'));
  $.ajax({
    url: url,
    type: 'POST',
    data: requestData,
    async: true,
    success: function(result) {
      self.$dialog.unbind();
      if (result.status == 'SUCCESS') {
        notify.showSuccess(yext.msg('Successfully cancelled updates! Your page will refresh momentarily.'));
        self.loadNextPage();
      } else {
        dialog.showErrorDialog(yext.msg('Error canceling scheduled update'));
      }
    },
    error: function() {
      dialog.showErrorDialog(yext.msg('Error canceling scheduled update'));
    },
    complete: function() {
      dialog.hideDelayedProgressDialog(self.dialogTimeout);
    },
  });
};

exports = CancelDialog;
